module.exports = __webpack_public_path__ + "img/christophe-mae-2024.1dd0d998.jpg";